module.exports = __webpack_public_path__ + "img/d200909-2.db6d6695.jpg";